import script from "./MakerCartGetStartedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGetStartedPage.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGetStartedPage.vue?vue&type=style&index=0&id=9331b464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9331b464"]])

export default __exports__